module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    key: _vm._isColmo + 'checkbox',
    staticClass: " weex-ct weex-div",
    class: [
      'dof-cell',
      !_vm.disabled && 'active-cell',
      _vm.hasTopBorder && 'cell-top-border',
      _vm.hasBottomBorder && 'cell-bottom-border',
      _vm.disabled && 'checkbox-disabled'
    ],
    style: (_vm._px2rem(_vm.cellDynamicHeight, 75)),
    attrs: {
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.dofCellClick($event)
      }
    }
  }, [(!_vm._isColmo) ? _c('figure', {
    staticClass: " weex-el weex-image",
    class: ['checkbox', _vm.disabled && 'checkbox-icon-disabled'],
    attrs: {
      "slot": "value",
      "src": _vm.checkIcon,
      "data-img-src": _vm.checkIcon,
      "weex-type": "image"
    },
    slot: "value"
  }) : _vm._e(), _vm._v(" "), (_vm._isColmo) ? _c('div', {
    staticClass: "circle weex-ct weex-div",
    style: ({
      backgroundColor: _vm.innerChecked ? '#b35336' : 'transparent',
      borderColor: _vm.innerChecked ? 'transparent' : '#797979'
    }),
    attrs: {
      "slot": "value",
      "weex-type": "div"
    },
    slot: "value"
  }, [(_vm.innerChecked) ? _c('dof-iconfont', {
    staticStyle: {
      "width": "0.53333rem"
    },
    attrs: {
      "code": '\u4729',
      "size": 40,
      "color": 'rgba(255, 255, 255, 0.8)'
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.itemImg && _vm.itemImg != '') ? _c('div', {
    staticClass: "avatar weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [(_vm.itemImg && _vm.itemImg != '') ? _c('figure', {
    staticClass: "item-img weex-el weex-image",
    attrs: {
      "src": _vm.itemImg,
      "data-img-src": _vm.itemImg,
      "weex-type": "image"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: " weex-ct weex-div",
    class: [
      'main-wrapper',
      _vm.hasSubTopBorder && 'checkBox-top-border',
      _vm.itemImg && _vm.hasSubBottomBorder && 'checkBox-bottom-border'
    ],
    style: (_vm._px2rem(_vm.dynamicSizeComp, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: "content-title weex-ct weex-div",
    style: (_vm._px2rem(_vm.titleDynamicHeight, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: "cell-title weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('p', {
    ref: "titleBox",
    staticClass: " weex-el weex-text",
    class: ['title-text', _vm.isOverflow && 'title-flex-expand'],
    attrs: {
      "slot": "title",
      "weex-type": "text"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.tag) ? _c('p', {
    ref: "tagBox",
    staticClass: "cell-title-btn weex-el weex-text",
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.tag))]) : _vm._e()]), _vm._v(" "), (_vm.desc) ? _c('div', {
    staticClass: "sub-title weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('p', {
    staticClass: "sub-text weex-el weex-text",
    attrs: {
      "slot": "sub-text",
      "weex-type": "text"
    },
    slot: "sub-text"
  }, [_vm._v(_vm._s(_vm.desc))])]) : _vm._e()]), _vm._v(" "), (_vm.hasArrow) ? _c('dof-image', {
    staticClass: "cell-arrow-icon",
    attrs: {
      "src": _vm.ARROW_ICON
    }
  }) : _vm._e()], 1), _vm._v(" "), (!_vm.itemImg && _vm.hasSubBottomBorder) ? _c('div', {
    staticClass: "fakeSubBorder weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }) : _vm._e(), _vm._v(" "), (_vm._isDiablo && _vm.disabled) ? _c('div', {
    staticClass: "disabledMask weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-60711b04", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60711b04","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-checkbox/index.vue
// module id = 620
// module chunks = 0 1